function checkIt(item, filterObj) {
  let keep = true;
  // eslint-disable-next-line no-restricted-syntax
  for (const key in filterObj) {
    if (typeof filterObj[key] === 'object') {
      keep = checkIt(item[key], filterObj[key]);
    } else if (filterObj[key] !== '__null__') {
      keep = keep && (item[key] == null ? '' : item[key]) === filterObj[key];
    }
  }
  return keep;
}

function listModification(input, paramExclude) {
  let exclude = paramExclude;
  if (!exclude) {
    exclude = 'deleted';
  }

  const out = [];
  if (input && input.length) {
    input.forEach((item) => {
      // eslint-disable-next-line no-underscore-dangle
      if (item._status !== exclude) {
        out.push(item);
      }
    });
  }
  return out;
}

function maskedPhone(number) {
  if (number.length === 10) {
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
  } if (number.length === 9) {
    return `0${number.slice(0, 3)} ${number.slice(3, 6)} ${number.slice(6, 9)}`;
  }
  return '0000000000';
}

function modeConversion(value, test) {
  if (!test) {
    return value;
  }

  let out = value;
  test.forEach((item) => {
    if (item.setting === value) {
      out = item.name;
    }
  });
  return out;
}

function objectProperties(input, filterBy) {
  const out = [];
  if (input && input.length) {
    input.forEach((item) => {
      const keep = checkIt(item, filterBy);

      if (keep) {
        out.push(item);
      }
    });
  }
  return out;
}

module.exports = {
  checkIt,
  listModification,
  maskedPhone,
  modeConversion,
  objectProperties: (input, filterBy = {}) => objectProperties(input, filterBy),
};
